
(() => {
  const marquee = document.querySelector('.marquee');
  const track = marquee?.querySelector('.marquee-track');
  const groups = track ? Array.from(track.querySelectorAll('.marquee-group')) : [];
  if (!marquee || !track || groups.length !== 2) return;

  const originalItems = Array.from(groups[0].children).map((item) => item.outerHTML).join('');
  let resizeTimer = 0;

  const rebuildMarquee = () => {
    track.style.animation = 'none';
    groups.forEach((group) => { group.innerHTML = originalItems; });

    const requiredWidth = marquee.clientWidth + 160;
    let safety = 0;
    while (groups[0].scrollWidth < requiredWidth && safety < 8) {
      groups.forEach((group) => group.insertAdjacentHTML('beforeend', originalItems));
      safety += 1;
    }

    void track.offsetWidth;
    track.style.animation = '';
  };

  rebuildMarquee();
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(rebuildMarquee, 120);
  }, { passive: true });
})();
